import { TransitionStatus } from 'react-transition-group/Transition';
import styled from 'styled-components';

import { blue, exactWhite, white, black, gray } from 'utils/style/colors';
import { zindex } from 'utils/style/zindex';

import { sidebarBackgroundColor } from 'components/Sidebar/styles';
import { languageDirection } from '../../i18n';
import NavLink from '../NavLink/NavLink';

type CollapsibleSubMenuProps = {
  open: boolean;
};

type PopperBaseProps = {
  transitionState: TransitionStatus;
};

const LINE_HEIGHT = 2.6;

export const POPPER_TRANSITION_DURATION = 300;

export const matchMenuLinkStyle: React.CSSProperties = {
  backgroundImage: `linear-gradient(${languageDirection() === 'rtl' ? 'to right' : 'to left'}, ${blue} 0%, ${exactWhite} 80%)`,
  color: black,
};

export const MenuLink = styled(NavLink).attrs({
  matchStyle: matchMenuLinkStyle,
} as any)`
  display: block;
  background-color: ${exactWhite};
  color: ${black};
  margin: 0 0.4rem 0 ${({ collapsed }) => (collapsed ? '0.4rem' : '1.5rem')};
  //padding: 0.4rem 0.1rem;
  border-radius: 0.7rem;
  //
  //&:hover {
  //  width: max-content;
  //}
`;

// submenu link is active whene hover over submenu when is collapsed
export const OverflowMenuLink = styled(MenuLink)`
  display: none;
`;

export const MenuWrapper = styled('ul')`
  background: ${sidebarBackgroundColor};
  box-shadow: none;
  color: ${black};
  flex: 1;
  margin: 0;
  overflow: visible;
  -ms-overflow-style: none;
  padding: 0 !important;
`;

export const MenuItemBase = styled('li')`
  align-items: center;
  background-color: transparent;
  color: ${black};
  cursor: pointer;
  display: flex;
  font-size: 0.875rem;
  height: ${LINE_HEIGHT}rem;
  justify-content: space-between;
  list-style: none;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  //width: 100%;
  margin: 0.4rem 0;

  .icon {
    font-size: 1rem;
    min-width: 0.875rem;
  }
  span {
    margin-inline-start: 0.625rem;
    max-width: 120px;
    overflow: hidden;
  }
  // &:hover {
  //   color: ${black};
  //   //overflow: visible;
  //   //background: transparent;
  // }
`;

export const MenuItemBaseContent = styled('div')`
  text-overflow: inherit;
  overflow: inherit;
  display: flex !important;
  align-items: center;
  margin: 0.25rem 0.5rem;
  position: relative;
`;

export const MenuItemBaseContentItem = styled.div`
  width: calc(100% - 2rem);
  z-index: 0;
  flex: 1;
  font-size: 1rem;
  padding: 0 0.5rem;
  overflow: visible;
`;

export const CollapsibleMenu = styled(MenuItemBase)`
  line-height: ${LINE_HEIGHT}rem;
  padding: 0;
  text-align: center;
  // recently added
  display: flex;
  justify-content: center;
  align-items: center;
  //
`;

export const CollapsibleSubMenu = styled(MenuItemBase)<CollapsibleSubMenuProps>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  ${(props) =>
    props.open &&
    `
    background-color: transparent;
    color: ${black};
  `}
`;

export const CollapsibleSubMenuHeader = styled('div')`
  display: flex;
  //recently added
  justify-content: center;
  align-items: center;
  //
`;

export const CollapsibleSubMenuHeaderContent = styled.div`
  flex: 1;
  padding-inline-start: 0.5rem;
`;

export const MenuDivider = styled('li')`
  background-color: #ccc;
  height: 1px;
  line-height: 0;
  overflow: hidden;
  padding: 0.05rem 0;
  width: 80%;
  margin: 0.5rem auto;
`;

export const UnreadBadge = styled.span`
  background-color: #34c8b6;
  border-radius: 0.25rem;
  color: var(--exact-white);
  font-size: 0.75rem;
  font-weight: normal;
  margin-inline-start: 2.5rem;
  padding: 0 0.375rem 0 0.375rem;
`;

export const UnreadBadgeCircle = styled.span`
  background-color: #34c8b6;
  border-radius: 1rem;
  color: var(--exact-white);
  font-size: 0.48rem;
  margin-inline-start: 2.5rem;
  padding: 0 0.375rem 0 0.375rem;
`;

export const PopperBase = styled('div')<PopperBaseProps>`
  transition: opacity 300ms ease-in-out;
  z-index: ${zindex.popover};
  ${(props) => {
    switch (props.transitionState) {
      case 'entering':
        return 'opacity: 1';
      case 'entered':
        return 'opacity: 1';
      case 'exiting':
        return 'opacity: 0';
      case 'exited':
        return 'opacity: 0';
      default:
        return '';
    }
  }}
`;

// normal PopOver
export const ToolTipPopover = styled(PopperBase)`
  background-color: ${sidebarBackgroundColor};
  height: 3.5rem;
  color: ${black};
  font-size: 0.875rem;
  line-height: ${LINE_HEIGHT}rem;
  padding: 0 1.56rem;
  user-select: none;
  white-space: nowrap;

  // PopOver Padding
  margin-inline-start: 0.3rem;
  /* box-shadow: -1rem 0 6rem ${gray}; */
  border: 0.05rem solid ${gray};

  ${(props) =>
    props.theme.direction === 'rtl'
      ? `border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;border-right: 0;`
      : `border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;border-left: 0;`}
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SubMenuItemBase = styled(MenuItemBase)`
  margin: 0.25rem 1rem;
  padding: 0;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  span {
    margin-inline-start: unset;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SubMenuItemBaseItem = styled.div`
  position: relative;
  width: calc(100% - 8rem);
  z-index: 0;
  flex: 1;
  font-size: 1rem;
  padding: 0 0.5rem;
  overflow: visible;
`;

export const SubMenuItemToolTip = styled(PopperBase)`
  span {
    margin-inline-start: unset;
  }
  gap: 9px;
  display: flex;
  align-items: center;
  background-color: inherit;
  color: ${white};
  cursor: pointer;
  font-size: 0.875rem;
  line-height: ${LINE_HEIGHT}rem;
  padding: 0 1.56rem;
  pointer-events: none;
  right: 0;
  white-space: nowrap;
  width: max-content;
`;

export const SubMenuWrapper = styled('div')<CollapsibleSubMenuProps>`
  display: flex;
  flex-direction: column;
  // recently added
  margin: 0 1rem;
  border-radius: 0.7rem;
  //padding: 0.4rem 0.1rem;
  overflow: hidden;
  transition: all cubic-bezier(0, 0, 0, 1) 0.4s;
  padding-inline-start: ${(props) =>
    props.theme.direction === 'ltr' ? '1rem' : '0'};
  ${({ open }) =>
    open &&
    `box-shadow: 0px 0 3px ${gray}
  
  margin-top: 0.5rem !important;
  `};
  /* padding: 0.1rem 0.7rem; */ //removing padding to be inlined vertically
  //
`;

export const SubMenuContent = styled('div')`
  /* background-color: blue; */
  background: ${exactWhite};
  margin-inline-start: 10px;
`;

// SubPopOver
export const SubMenuPopover = styled('div')`
  background-color: var(--exact-white);
  //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45) inset;
  display: flex;
  flex-direction: column;
  // submenu popover

  // style submenu popover
  border: 0.05rem solid ${gray};
  ${(props) =>
    props.theme.direction === 'rtl'
      ? `border-right: 0;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;`
      : `border-left: 0;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;`}
  overflow: hidden;
`;

export const SubMenuPopoverLabel = styled('span')`
  background-color: ${sidebarBackgroundColor};
  border-bottom: 1px solid #c8cee0;
  color: ${black};
  padding: 0.5rem 0.8rem;
  text-align: center;
  user-select: none;
  white-space: nowrap;
`;

export const SubMenuPopoverContent = styled(SubMenuContent)`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  max-height: ${LINE_HEIGHT * 7}rem;
  -ms-overflow-style: none;
  overflow: auto;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    background: transparent;
    width: 0;
  }
`;
